import VueRouter from "vue-router";
import Vue from "vue";
Vue.use(VueRouter);

import Home from "../view//v2/Home.vue";
import Team from "../view/v1/Team.vue";
import Join from "../view/v1/Join.vue";
import Err from "../view/Err.vue";
import checkOauth from "./oauth/v2";

const routes = [
  // 成为团长
  { path: "/", component: Home, name: "OpenGroup" },
  // 组队页面
  { path: "/team/:teamID", component: Team, name: "Team" },
  // 加入队伍
  { path: "/join/:teamID", component: Join, name: "Join" },
  // 404
  { path: "/err/", component: Err, name: "Err" },
];

const router = new VueRouter({
  base: "/rebate/",
  // 重点：本地运行使用hash，打包使用history
  mode: "history",
  routes,
});

router.afterEach(() => {
  if (window && window.wx) {
    new Promise((resolve, reject) => {
      Vue.prototype
        .$ajax({
          method: "get",
          url: Vue.prototype.$api.getWechat,
          params: {
            remark: "sy-top",
            redirect_url: window.location.href,
          },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    }).then((data) => {
      let wxData = data;
      wxData.jsApiList = ["onMenuShareTimeline", "onMenuShareAppMessage"];
      window.wx.config({
        debug: false, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
        appId: wxData.appId, // 必填，公众号的唯一标识
        timestamp: wxData.timestamp, // 必填，生成签名的时间戳
        nonceStr: wxData.nonceStr, // 必填，生成签名的随机串
        signature: wxData.signature, // 必填，签名
        jsApiList: wxData.jsApiList, // 必填，需要使用的 JS 接口列表
      });
      window.wx.ready(() => {
        const shareData = {
          title: "【队友邀请】星辉618赏金赛",
          link: window.location.href,
          imgUrl: "https://m.rastargame.com/rebateSharImg/share.jpg",
          desc: "加入我的队伍，一起领取充值返利！",
        };
        window.wx.onMenuShareTimeline({
          title: shareData.title,
          link: shareData.link,
          imgUrl: shareData.imgUrl,
          success: function () {
            // 分享到朋友圈 用户确认分享后执行的回调函数
            console.log("分享到朋友圈ok");
          },
          fail: function (res) {
            console.log("分享到朋友圈==", JSON.stringify(res));
          },
        });
        window.wx.onMenuShareAppMessage({
          title: shareData.title,
          link: shareData.link,
          imgUrl: shareData.imgUrl,
          desc: shareData.desc,
          success: function () {
            // 分享给朋友 用户确认分享后执行的回调函数
            console.log("分享给朋友，ok");
          },
          fail: function (res) {
            console.log("分享给朋友==", JSON.stringify(res));
          },
        });
      });
      window.wx.error((err) => {
        console.error(err);
      });
    });
  }
});

checkOauth(router);

export default router;
